import src from "IMAGE";
export default { src, width: 121, height: 32, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAMklEQVR42m3HQQ0AIAgAQEKRwCQaAxvQBRv4IBZjY0AAHvc4wMO67ssRSQBu/h0fkVgBrrQlPZnOTTsAAAAASUVORK5CYII="};
